var map = {
	"./back_arrow.svg": "3ce8",
	"./home_background.svg": "ec34",
	"./home_pixel.svg": "ed85",
	"./logo_1.svg": "d4d9",
	"./logo_2.svg": "ea7d",
	"./logo_3.svg": "f310",
	"./logo_4.svg": "9b3c",
	"./logo_5.svg": "1e69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";